import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Container, Typography, styled } from "@mui/material";
import Footer from "../componentsPeopletech/Footer/Footer";

const TermsContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(8),
  backgroundColor: "#ffffff",
  maxWidth: "900px",
}));

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: "2.5rem",
  marginBottom: theme.spacing(4),
  textAlign: "center",
  color: "#000000",
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem",
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "1.5rem",
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(2),
  color: "#1c2859",
}));

const SectionText = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  lineHeight: 1.8,
  color: "#414141",
  marginBottom: theme.spacing(2),
}));

const LastUpdated = styled(Typography)(({ theme }) => ({
  fontSize: "0.9rem",
  color: "#666",
  fontStyle: "italic",
  marginBottom: theme.spacing(4),
  textAlign: "center",
}));

function dateLocaleForI18n(lang) {
  if (!lang || typeof lang !== "string") return "en-GB";
  const base = lang.split("-")[0].toLowerCase();
  if (base === "es") return "es-ES";
  if (base === "en") return lang.toLowerCase().includes("us") ? "en-US" : "en-GB";
  return "en-GB";
}

const TermsOfService = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || "en";
  const baseUrl = "https://www.peoplefortech.com";
  const dateLocale = dateLocaleForI18n(currentLang);
  const formattedDate = new Date().toLocaleDateString(dateLocale, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <>
      <Helmet>
        <title>{t("termsOfService.pageTitle")}</title>
        <meta name="description" content={t("termsOfService.metaDescription")} />
        <link rel="canonical" href={`${baseUrl}/terms-of-service`} />
        <html lang={currentLang} />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${baseUrl}/terms-of-service`} />
        <meta property="og:title" content={t("termsOfService.ogTitle")} />
        <meta property="og:description" content={t("termsOfService.ogDescription")} />
      </Helmet>

      <TermsContainer>
        <Title variant="h1">{t("termsOfService.heading")}</Title>
        <LastUpdated>
          {t("termsOfService.lastUpdatedLabel")} {formattedDate}
        </LastUpdated>

        <SectionTitle variant="h2">{t("termsOfService.section1Title")}</SectionTitle>
        <SectionText>{t("termsOfService.section1Body")}</SectionText>

        <SectionTitle variant="h2">{t("termsOfService.section2Title")}</SectionTitle>
        <SectionText>{t("termsOfService.section2Body")}</SectionText>

        <SectionTitle variant="h2">{t("termsOfService.section3Title")}</SectionTitle>
        <SectionText>{t("termsOfService.section3Body")}</SectionText>

        <SectionTitle variant="h2">{t("termsOfService.section4Title")}</SectionTitle>
        <SectionText>{t("termsOfService.section4Body")}</SectionText>

        <SectionTitle variant="h2">{t("termsOfService.section5Title")}</SectionTitle>
        <SectionText>{t("termsOfService.section5Body")}</SectionText>

        <SectionTitle variant="h2">{t("termsOfService.section6Title")}</SectionTitle>
        <SectionText>{t("termsOfService.section6Body")}</SectionText>

        <SectionTitle variant="h2">{t("termsOfService.section7Title")}</SectionTitle>
        <SectionText>{t("termsOfService.section7Body")}</SectionText>

        <SectionTitle variant="h2">{t("termsOfService.section8Title")}</SectionTitle>
        <SectionText>{t("termsOfService.section8Body")}</SectionText>
      </TermsContainer>
      <Footer />
    </>
  );
};

export default TermsOfService;
